var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsCubeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.406 6.58601L12.406 2.58601C12.278 2.52914 12.1395 2.49976 11.9995 2.49976C11.8595 2.49976 11.721 2.52914 11.593 2.58601L2.593 6.58601C2.573 6.59501 2.559 6.61001 2.539 6.62101C2.511 6.63501 2.481 6.64401 2.455 6.66101C2.433 6.67601 2.416 6.69501 2.395 6.71101C2.3219 6.76533 2.25779 6.8308 2.205 6.90501C2.185 6.93301 2.164 6.95801 2.146 6.98601C2.11624 7.03886 2.09082 7.09404 2.07 7.15101C2.061 7.17801 2.047 7.20301 2.039 7.23001C2.01389 7.31784 2.00077 7.40866 2 7.50001V17.5C2 17.896 2.232 18.253 2.594 18.414L11.594 22.414C11.724 22.472 11.862 22.5 12 22.5C12.1392 22.4964 12.2762 22.4637 12.402 22.404L12.406 22.414L21.406 18.414C21.5829 18.3356 21.7332 18.2074 21.8386 18.0452C21.9441 17.8829 22.0002 17.6935 22 17.5V7.50001C22.0002 7.3065 21.9441 7.11711 21.8386 6.95485C21.7332 6.7926 21.5829 6.66446 21.406 6.58601ZM12 4.59501L18.538 7.50001L12 10.405L10.692 9.82401L5.463 7.50001L12 4.59501ZM13 19.961V12.15L20 9.03901V16.851L13 19.961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsCubeWhite);
export default __webpack_public_path__ + "static/media/bxs_cube_white.8c2f2b84c6048bed9146104d4476a026.svg";
export { ForwardRef as ReactComponent };